import base from './base'
import admin from './admin'
import home from './home'
import pg from './pg'
import cq from './cq'
import archive from './archive'
import finance from './finance'
import manage from './manage'
import performance from './performance'
import fill from './fill'
import tool from './tool'
import th from './th'

export default {
  ...base,
  ...admin,
  ...home,
  ...pg,
  ...cq,
  ...archive,
  ...finance,
  ...manage,
  ...performance,
  ...fill,
  ...tool,
  ...th
}



// WEBPACK FOOTER //
// ./src/api/index.js